/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

const aTouchAwayMobile = require("../models/main/aTouchAwayMobile.js");

// General utilities
const Sounds = require("../models/sounds/Sounds.js");
const SoundsPreferences = require("../models/sounds/SoundsPreferences.js");
const Localization = require("../models/Localization.js");
const Theme = require("../models/theme/Theme.js");
const Online = require("../models/available/Online.js");
const AvailabilityNotifier = require("../models/available/AvailabilityNotifier.js");
const SelfDestructor = require("../models/SelfDestructor.js");
const DesktopSounds = require("../models/sounds/DesktopSounds");
const LoadedSounds = require("../models/sounds/LoadedSounds");
const LoadChecker = require("../models/available/LoadChecker.js");
const MessageSound = require("../models/sounds/MessageSound");
const LinkOpener = require("../models/LinkOpener.js");
const AudioOutputSelector = require("../models/call/AudioOutputSelector");
const VersionInfo = require("../models/people/VersionInfo");

// Keeping alive in the background on iOS
const BackgroundSocket = require("../models/available/BackgroundSocket.js");
const NetworkStatus = require("../models/available/NetworkStatus.js");

// Stuff to do with other people
const People = require("../models/people/People.js");
const ContactList = require("../models/contacts/ContactList.js");
const Availability = require("../models/available/Availability.js");
const ContactPage = require("../models/contacts/ContactPage.js");

// Urgency call stuff
const UrgencyPreferences = require("../models/urgency/UrgencyPreferences.js");
const UrgencyContacts = require("../models/urgency/UrgencyContacts.js");
const AvailableUrgencyContacts = require("../models/urgency/AvailableUrgencyContacts.js");
const NextUrgencyContact = require("../models/urgency/NextUrgencyContact.js");
const UrgencyHistory = require("../models/urgency/UrgencyHistory.js");
const UrgencyCalls = require("../models/urgency/UrgencyCalls.js");

// Stuff to do with calls
const Options = require("../models/desktop/Options.js");
const ConferenceInviter = require("../models/call/ConferenceInviter.js");
const InputOptions = require("../models/desktop/InputOptions.js");
const Calling = require("../models/call/Calling.js");
const MissedCall = require("../models/call/MissedCall.js");
const MissedVoiceCall = require("../models/call/MissedVoiceCall.js");
const LatestMessages = require("../models/messages/LatestMessages.js");
const Notifications = require("../models/notifications/Notifications.js");
const BackgroundNotifications = require("../models/notifications/BackgroundNotifications.js");
const CallInputSwitcher = require("../models/desktop/CallInputSwitcher.js");
const DesktopToast = require("../models/notifications/DesktopToast.js");
const Toast = require("../models/notifications/Toast.js");

// Info about the current user
const PersonalData = require("../models/people/PersonalData.js");
const Header = require("../models/people/Header.js");
const Footer = require("../models/atouchaway/Footer.js");
const UsersManagerList = require("../models/manage/UsersManagerList.js");
const TimezoneSetter = require("../models/people/TimezoneSetter");

// Careplan
const CareplanSection = require("../models/careplan/CareplanSection.js");
const CareplanProposedChanges = require("../models/careplan/CareplanProposedChanges.js");
const OwnCareplan = require("../models/careplan/OwnCareplan.js");
const CareplanOverlay = require("../models/careplan/CareplanOverlay.js");

// Atouchaway stuff
const ATouchAwaySettings = require("../models/atouchaway/ATouchAwaySettings.js");
const ATouchAwayMessaging = require("../models/atouchaway/ATouchAwayMessaging.js");
const ScreenHider = require("../models/atouchaway/ScreenHider.js");
const MachineIndex = require("../models/atouchaway/MachineIndex.js");
const MachineTracker = require("../models/atouchaway/MachineTracker.js"); // Also required for bracelets
const AboutBox = require("../models/atouchaway/AboutBox.js");
const ContentUpdate = require("../models/atouchaway/ContentUpdate");
const UpdateRefresher = require("../models/atouchaway/UpdateRefresher");
const Refresher = require("../models/atouchaway/Refresher.js");
const RingFixer = require("../models/call/RingFixer.js");
const KnoxUnlock = require("../models/atouchaway/KnoxUnlock.js");
const Reminders = require("../models/reminders/Reminders.js");
const RemindersHistory = require("../models/reminders/RemindersHistory.js");
const ActiveReminder = require("../models/reminders/ActiveReminder.js");

const TrialData = require("../models/nologin/TrialData.js");
const Surveyprocessing = require("../models/surveys/SurveyProcessing.js");
const CoreForms = require("../models/forms/CoreForms.js");
const SurveyAutomate = require("../models/surveys/SurveyAutomate.js");
const SurveySettings = require("../models/surveys/SurveySettings.js");
const NewReading = require("../models/myhealth/NewReading.js");
const Comment = require("../models/myhealth/Comment.js");
const Groups = require("../models/groupchat/Groups.js");
const ATouchAwayGroupedMessages = require("../models/messages/AtouchawayGroupedMessages.js");
const MissedNotifications = require("../models/notifications/MissedNotifications.js");
const UnreadNotifications = require("../models/notifications/UnreadNotifications.js");
const MissedMessages = require("../models/messages/MissedMessages.js");
const MessagingContacts = require("../models/atouchaway/MessagingContacts.js");
const BasicMissedMessages = require("../models/messages/ATouchAwayMissedMessages.js");

// Bracelet stuff
const Bracelet = require("../models/bracelet/Bracelet.js");
const BraceletEvents = require("../models/bracelet/BraceletEvents.js");
const OwnBraceletEvents = require("../models/bracelet/OwnBraceletEvents.js");
const BraceletFinder = require("../models/bracelet/BraceletFinder.js");
const BraceletReconnector = require("../models/bracelet/BraceletReconnector.js");
const Bracelets = require("../models/bracelet/Bracelets.js");
const BraceletSettings = require("../models/bracelet/BraceletSettings.js");
const BraceletOwner = require("../models/bracelet/BraceletOwner.js");
const BraceletDisconnector = require("../models/bracelet/BraceletDisconnector.js");
const GroupMachines = require("../models/bracelet/GroupMachines.js");
const AvailableMachines = require("../models/bracelet/AvailableMachines.js");
const MachineEvents = require("../models/bracelet/MachineEvents.js");
const Bluetooth = require("../models/bluetooth/Bluetooth.js");
const BluetoothScanner = require("../models/bluetooth/BluetoothScanner.js");
const BluetoothOnOff = require("../models/bluetooth/BluetoothOnOff.js");
const MachineStateLogger = require("../models/bracelet/MachineStateLogger.js");
const RemoteBraceletScanner = require("../models/bracelet/RemoteBraceletScanner.js");
const RemoteBluetoothScanner = require("../models/bluetooth/RemoteBluetoothScanner.js");
const BraceletFindEvents = require("../models/bracelet/BraceletFindEvents.js");
const BraceletBatteryNotifier = require("../models/bracelet/BraceletBatteryNotifier.js");
const Overview = require("../models/myhealth/Overview.js");
const Activity = require("../models/myhealth/Activity.js");
const BloodSugar = require("../models/myhealth/BloodSugar.js");
const BloodPressure = require("../models/myhealth/BloodPressure.js");
const Weight = require("../models/myhealth/Weight.js");
const BloodOxygen = require("../models/myhealth/BloodOxygen.js");
const BodyTemperature = require("../models/myhealth/BodyTemperature.js");
const CustomIndicator = require("../models/myhealth/CustomIndicator");
const CustomIndicatorsList = require("../models/myhealth/CustomIndicatorsList");

const DeviceGlucoseTNG = require("../models/myhealth/DeviceGlucoseTNG.js");
const DeviceActivity = require("../models/myhealth/DeviceActivity.js");
const DeviceTemperature = require("../models/myhealth/DeviceTemperature.js");

const OrientationLocker = require("../models/orientation/OrientationLocker.js");
const Size = require("../models/orientation/Size.js");
const TooSmall = require("../models/orientation/TooSmall.js");
const ScreenLocker = require("../models/atouchaway/ScreenLocker.js");
const ScreenSaver = require("../models/atouchaway/ScreenSaver.js");
const KeepAwake = require("../models/keepawake/KeepAwake.js");
const Keyboard = require("../models/atouchaway/Keyboard.js");
const FileViewer = require("../models/FileViewer.js");
const Backbutton = require("../models/Backbutton");

// Workflow stuff
const ActiveWorkflowAction = require("../models/workflow/ActiveWorkflowAction.js");
const WorkflowActionAutoviewer = require("../models/workflow/WorkflowActionAutoviewer.js");
const WorkflowActions = require("../models/workflow/WorkflowActions.js");
const WorkflowDefinitions = require("../models/workflow/WorkflowDefinitions.js");
const WorkflowInstances = require("../models/workflow/WorkflowInstances.js");
const WorkflowActionPending = require("../models/workflow/WorkflowActionPending.js");
const WorkflowExternals = require("../models/workflow/WorkflowExternals.js");

const MetawearScheduler = require("../models/myhealth/MetawearScheduler");
const MyHealthDevice = require("../models/myhealth/myHealthDevice");
const FeedbackModal = require("../models/notifications/FeedbackModal");
const OwnFormList = require("../models/forms/OwnFormList");
const OwnFormSubmissions = require("../models/forms/OwnFormSubmissions");
const ActiveOwnFormSubmission = require("../models/forms/ActiveOwnFormSubmission");
const ActiveOwnFormPrepopulate = require("../models/forms/ActiveOwnFormPrepopulate");
const OrgGroup = require("../models/forms/OrgGroup");
const PauseScreen = require("../models/atouchaway/PauseScreen");
const CallGroups = require("../models/callgroups/CallGroups");
const InCall = require("../models/people/InCall");
const CallGroupCalling = require("../models/callgroups/CallGroupCalling");
const CallGroupMembers = require("../models/callgroups/CallGroupMembers");

const OwnResources = require("../models/resources/OwnResources");
const OwnResourcesList = require("../models/resources/OwnResourcesList");

const OwnStatus = require("../models/status/OwnStatus.js");
const OwnDevices = require("../models/devices/OwnDevices");
const DeviceFollowUp = require("../models/myhealth/DeviceFollowUp");

const License = require("../models/main/License");
const PrivacyPolicy = require("../models/main/PrivacyPolicy");
const OwnManageGroup = require("../models/managegroup/OwnManageGroup");
const AccountSwitcher = require("../models/desktop/AccountSwitcher");
const AppRefresher = require("../models/desktop/AppRefresher");

const DeviceOxygen = require("../models/myhealth/devices/bloodoxygen/DeviceOxygen");
const DeviceNonin3230 = require("../models/myhealth/devices/bloodoxygen/DeviceNonin3230");
const DeviceForaSPO2 = require("../models/myhealth/devices/bloodoxygen/DeviceForaSPO2");
const DeviceIHO2 = require("../models/myhealth/devices/bloodoxygen/DeviceIHO2");

const DeviceBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceBloodPressure");
const DeviceANDBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceA&DBloodPressure");
const DeviceIHBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceIHBloodPressure");
const DeviceBIOSBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceBIOSBloodPressure");

const DeviceWeight = require("../models/myhealth/devices/weight/DeviceWeight");
const DeviceANDWeight = require("../models/myhealth/devices/weight/DeviceA&DWeight");
const DeviceIHWeight = require("../models/myhealth/devices/weight/DeviceIHWeight");

const OwnFormOrderList = require("../models/forms/OwnFormOrderedList");

const CustomOptions = require("../models/options/CustomOptions");
const PersistStorage = require("../models/persiststorage/PersistStorage");
const GroupSettings = require("../models/organization/GroupSettings.js");

const Save = require("../models/desktop/Save.js");
const SettingsOpener = require("../models/desktop/SettingsOpener");

const Refresh = require("../models/main/Refresh");
const Logout = require("../models/main/Logout");
const Banners = require("../models/notifications/Banners");
const UserMetrics = require("../models/usermetrics/UserMetrics");

const create = require("./create.js");

// eslint-disable-next-line node/no-missing-require
const { Platform } = require("react-native");

const models = [
	Refresh,
	Logout,
	VersionInfo,
	PersistStorage,
	Overview,
	MyHealthDevice,
	FeedbackModal,
	WorkflowDefinitions,
	WorkflowInstances,
	WorkflowActions,
	WorkflowActionPending,
	ActiveOwnFormSubmission,
	ActiveOwnFormPrepopulate,
	ActiveWorkflowAction,
	WorkflowActionAutoviewer,
	aTouchAwayMobile,
	ATouchAwayGroupedMessages,
	ATouchAwaySettings,
	ATouchAwayMessaging,
	Availability,
	AvailabilityNotifier,
	AvailableMachines,
	AvailableUrgencyContacts,
	BackgroundNotifications,
	BackgroundSocket,
	BloodSugar,
	BloodPressure,
	BloodOxygen,
	BodyTemperature,
	Weight,
	CustomIndicator,
	CustomIndicatorsList,
	BasicMissedMessages,
	Bluetooth,
	BluetoothOnOff,
	BluetoothScanner,
	Bracelet,
	BraceletBatteryNotifier,
	BraceletDisconnector,
	BraceletEvents,
	BraceletFinder,
	BraceletFindEvents,
	BraceletOwner,
	BraceletReconnector,
	Bracelets,
	BraceletSettings,
	Calling,
	CallGroups,
	CallGroupCalling,
	CallGroupMembers,
	CallInputSwitcher,
	Comment,
	ConferenceInviter,
	ContactList,
	ContactPage,
	ContactPage,
	CoreForms,
	DesktopSounds,
	Backbutton,
	FileViewer,
	Footer,
	GroupMachines,
	Groups,
	Header,
	InCall,
	InputOptions,
	LatestMessages,
	LoadChecker,
	LoadedSounds,
	Localization,
	MachineEvents,
	MachineIndex,
	MachineStateLogger,
	Activity,
	MessagingContacts,
	MissedNotifications,
	ContentUpdate,
	Refresher,
	RingFixer,
	UpdateRefresher,
	Keyboard,
	KnoxUnlock,
	AboutBox,
	MachineTracker,
	MissedMessages,
	MissedCall,
	MissedVoiceCall,
	NetworkStatus,
	NextUrgencyContact,
	Notifications,
	NewReading,
	Online,
	Options,
	OrientationLocker,
	OrgGroup,
	OwnFormList,
	OwnFormSubmissions,
	ScreenLocker,
	KeepAwake,
	ScreenSaver,
	Size,
	TooSmall,
	OwnBraceletEvents,
	PauseScreen,
	People,
	PersonalData,
	Reminders,
	RemoteBraceletScanner,
	RemoteBluetoothScanner,
	CareplanSection,
	CareplanProposedChanges,
	CareplanOverlay,
	OwnCareplan,
	OwnStatus,
	ScreenHider,
	SelfDestructor,
	Theme,
	TrialData,
	DesktopToast,
	Toast,
	UnreadNotifications,
	UrgencyCalls,
	UrgencyContacts,
	UrgencyHistory,
	UrgencyPreferences,
	Surveyprocessing,
	SurveyAutomate,
	SurveySettings,
	UsersManagerList,
	MessageSound,
	Sounds,
	SoundsPreferences,
	TimezoneSetter,
	MetawearScheduler,
	RemindersHistory,
	ActiveReminder,
	DeviceGlucoseTNG,
	DeviceActivity,
	DeviceTemperature,
	OwnResources,
	OwnResourcesList,
	OwnDevices,
	OwnManageGroup,
	DeviceFollowUp,
	License,
	PrivacyPolicy,
	WorkflowExternals,
	AccountSwitcher,
	AppRefresher,
	DeviceOxygen,
	DeviceNonin3230,
	DeviceForaSPO2,
	DeviceIHO2,
	DeviceBloodPressure,
	DeviceANDBloodPressure,
	DeviceBIOSBloodPressure,
	DeviceIHBloodPressure,
	DeviceWeight,
	DeviceANDWeight,
	DeviceIHWeight,
	OwnFormOrderList,
	CustomOptions,
	LinkOpener,
	AudioOutputSelector,
	Banners,
	GroupSettings,
	Save,
	SettingsOpener,
	UserMetrics,
];

if(Platform.OS === "android" || Platform.OS === "ios"){
	const CallPendingList = require("../models/call/PendingCall.js");
	const RemotePushHandler = require("../models/notifications/RemotePushHandler.js");
	models.push(RemotePushHandler);
	models.push(CallPendingList);
}

module.exports = create(models, "atouchawaymobile");